<script setup lang="ts">
defineProps<{
    size?: "sm" | "md" | "lg";
}>();
</script>

<template>
    <div class="spinner" :class="`spinner--${size || 'md'}`">
        <div class="spinner__circle" />
    </div>
</template>

<style scoped>
.spinner {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.spinner__circle {
    border-radius: 50%;
    border-style: solid;
    border-color: #3b82f6 transparent transparent transparent;
    animation: spin 1s linear infinite;
}

.spinner--sm .spinner__circle {
    width: 16px;
    height: 16px;
    border-width: 2px;
}

.spinner--md .spinner__circle {
    width: 24px;
    height: 24px;
    border-width: 3px;
}

.spinner--lg .spinner__circle {
    width: 40px;
    height: 40px;
    border-width: 4px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
